export const Images = {
    NotFoundImage: require('./images/NotFound.jpg'),
    DummyCover: require('./images/DummyCover.png'),
    VideoPlaceHolder: require('./images/video-placeholder.png'),
    Logo: require('./svgs/logo.svg')?.default,
    SideBarCloseIcon: require('./svgs/sidebariconclose.svg')?.default,
    SideBarOpenIcon: require('./svgs/sidebariconopen.svg')?.default,
    MaleUser: require('./images/male.png'),
    FemaleUser: require('./images/female.png'),
}
